module.exports = __webpack_public_path__ + "assets/a-5-mianqian.9c4cf0a7.svg";